import React from 'react';
import { twMerge } from 'tailwind-merge';

import Button, { ButtonVariant } from 'components/Button/Button';
import { t } from 'locales/i18n';

interface IntegrationCardProps {
  title: string;
  description: string;
  website: string;
  logo: string;
  backgroundColor: string;
  setValue: (value: string) => void;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  title,
  description,
  website,
  logo,
  backgroundColor,
  setValue,
}) => {
  const overlayClassname = twMerge(
    'absolute',
    'group-hover:bg-opacity-10',
    'bg-kira-blue-300',
    'group-hover:flex',
    'h-full',
    'hidden',
    'justify-center',
    'right-0',
    'top-0',
    'w-full'
  );

  return (
    <div className="max-w-80 group relative inline-block rounded-lg border border-kira-slate-200 bg-kira-slate-0 p-6 hover:border-kira-blue-300">
      <div className="space-y-4 transition-all duration-200 ease-in-out group-hover:blur-sm">
        <div className="flex justify-between">
          <div>
            <div className="prose-title-h2 text-kira-slate-900">{title}</div>
            <div className="prose-body-sm-reg text-kira-slate-700">
              {website}
            </div>
          </div>
          <div
            className={`${backgroundColor} hidden h-16 w-20 justify-center rounded px-2 py-4 align-middle lg:flex`}
          >
            <img src={logo} alt={`${title} logo`} />
          </div>
        </div>
        <div className="prose-body-sm-reg text-kira-slate-800">
          {description}
        </div>
      </div>
      <div className={overlayClassname}>
        <Button
          buttonText={t('Request More Info')}
          variant={ButtonVariant.PRIMARY}
          onClick={() => setValue(title)}
        />
      </div>
    </div>
  );
};
export default IntegrationCard;
